import React, { useCallback, useContext, useState } from "react";

import useT from "../../hooks/useT";
import AppFrame from "../../components/AppFrame";
import Page from "../../components/Page";
import Field from "../../components/Field";
import Button from "../../components/Button";
import CustomersTable from "../../components/CustomersTable";
import LoadingScreen from "../../components/LoadingScreen";
import AppLanguageSwitcher from "../AppLanguageSwitcher";
import AppLayoutHeaderLeftCancel from "../AppLayout/AppLayoutHeaderLeftCancel";
import { ExistingCustomerDataStateObject } from "../../hooks/useCustomerDataState";
import { AppStateContext } from "../App";
import api from "../../utils/api";
import { getConfigValue } from "../../config";
import debug from "../../utils/debug";

export function AppHeaderRightContent() {
  return <AppLanguageSwitcher />;
}

export default function SearchPage() {
  const { t } = useT();
  const [searchWord, setSearchWord] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [noResults, setNoResults] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);
  const [customers, setCustomers] = useState<
    ExistingCustomerDataStateObject[]
  >();
  const [appState] = useContext(AppStateContext);

  const columns = getConfigValue(
    appState.zone,
    "customise.searchCustomer.resultsFields"
  );
  const detailsColumns =
    getConfigValue(appState.zone, "customise.searchCustomer.detailsColumns") ||
    columns;

  const enableEdit = getConfigValue(
    appState.zone,
    "customise.searchCustomer.enableEdit"
  );
  const clear = (): React.MouseEventHandler => (event: React.MouseEvent) => {
    setSearchWord("");
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchWord(event.target.value);
    //search();
  };

  const handleFormSubmit = useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();
      search();
    },
    [searchWord]
  );

  const search = () => {
    //debug("[search] searching for:", searchWord);
    if (!searchWord) {
      return;
    }
    setIsLoading(true);
    setNoResults(false);
    setHasError(false);
    api
      .searchCustomers(searchWord, appState)
      .then((results: any[]) => {
        //debug("[search] results:", results);
        setIsLoading(false);
        if (results && results.length) {
          setCustomers(results);
        } else {
          setCustomers([]);
          setNoResults(true);
        }
      })
      .catch(err => {
        debug("[search] error:", err);
        setHasError(true);
        setIsLoading(false);
      });
  };

  return (
    <AppFrame
      headerLeftContent={
        <AppLayoutHeaderLeftCancel label="general.buttons.back.label" />
      }
      headerRightContent={<AppHeaderRightContent />}
    >
      <Page name="search">
        <form className="search-form" onSubmit={handleFormSubmit}>
          <Field
            type="text"
            id="search-word"
            name="searchWord"
            label={t("search.field.label")}
            value={searchWord}
            onClear={clear}
            onChange={handleSearchChange}
          />
          <Button
            label={t("actions.searchCustomer.label")}
            theme="primary"
            onClick={search}
          />
        </form>
        <br />
        {(customers && customers.length && (
          <CustomersTable
            customers={customers}
            columns={columns}
            detailsColumns={detailsColumns}
            enableEdit={enableEdit}
          />
        )) ||
          ""}
        {noResults && <span>{t("actions.searchCustomer.noResults")}</span>}
        {hasError && <span>{t("actions.searchCustomer.error")}</span>}
        {isLoading && <LoadingScreen />}
      </Page>
    </AppFrame>
  );
}
